import type { Channel, PusherClient, SubscribePayload } from '@getaccept/pusher';
import { createEventHook, whenever } from '@vueuse/core';
import type { MaybeRef } from 'vue';
import { computed, onUnmounted, ref, unref } from 'vue';

export const usePusherChannel = (
  pusherClient: PusherClient,
  payload: MaybeRef<SubscribePayload>,
  options?: {
    enabled: MaybeRef<boolean>;
  }
) => {
  const enabled = computed(() => unref(options?.enabled) ?? true);
  const channel = ref<Channel>();
  const onSubscribed = createEventHook();
  const subscribed = computed(() => !!channel.value);

  const subscribe = async () => {
    if (subscribed.value) return;
    channel.value = await pusherClient.subscribe(unref(payload));
    onSubscribed.trigger(channel.value);
    return channel.value;
  };

  whenever(enabled, subscribe, { immediate: true });

  onUnmounted(() => {
    if (!subscribed.value) return;
    pusherClient.unsubscribe(channel.value);
  });

  return { channel, subscribed, onSubscribed: onSubscribed.on, subscribe };
};
